import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../data/notification";
import useT from "../../i18n/useT";
import core from "../../core";

const Broadcast = () => {
    const t = useT();
    const dispatch = useDispatch();
    const role = useSelector((state) => state.user.role);
    const isStaff = role === "admin" || role === "moderator";
    const isAdmin = role === "admin";

    const [history, setHistory] = useState([]);
    const [updates, setUpdates] = useState(0);
    const [form, setForm] = useState({ title: "", body: "", audience: "all", link: "" });
    const [sending, setSending] = useState(false);

    const notify = (text, type) => {
        dispatch(notificationActions.changeNotification({ show: true, text, type }));
        setTimeout(() => dispatch(notificationActions.changeNotification({ show: false, text: "", type: "" })), 4000);
    };

    useEffect(() => {
        if (!isStaff) return;
        axios.get("/api/broadcasts").then((res) => setHistory(res.data.data || [])).catch(() => {});
    }, [isStaff, updates]);

    if (!isStaff) {
        return <div className="page-content-main-container"><h2 className="page-title">{t("broadcast.title")}</h2></div>;
    }

    const send = (e) => {
        e.preventDefault();
        if (!form.title.trim()) return;
        setSending(true);
        axios.post("/api/broadcasts", form)
            .then((res) => { notify(`${res.data.message.en} (${res.data.data.recipient_count})`, "success-notification"); setForm({ title: "", body: "", audience: form.audience, link: "" }); setUpdates((u) => u + 1); })
            .catch((err) => notify(err.response?.data?.message?.en || "Error", "error-notification"))
            .finally(() => setSending(false));
    };

    const audienceLabel = (a) => t(`broadcast.${a}`);

    return (
        <div className="page-content-main-container">
            <h2 className="page-title">{t("broadcast.title")}</h2>

            {isAdmin && (
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: "12px", padding: "18px", marginBottom: "22px", maxWidth: "640px" }}>
                    <h3 style={{ fontSize: "15px", marginBottom: "14px" }}>{t("broadcast.compose")}</h3>
                    <form onSubmit={send}>
                        <div style={{ marginBottom: "10px" }}>
                            <label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("broadcast.subject")}</label>
                            <input type="text" className="form-control" value={form.title} onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))} required />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("broadcast.body")}</label>
                            <textarea className="form-control" rows={3} value={form.body} onChange={(e) => setForm((p) => ({ ...p, body: e.target.value }))} />
                        </div>
                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "14px" }}>
                            <div style={{ flex: "1 1 160px" }}>
                                <label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("broadcast.audience")}</label>
                                <select className="form-control" value={form.audience} onChange={(e) => setForm((p) => ({ ...p, audience: e.target.value }))}>
                                    <option value="all">{t("broadcast.all")}</option>
                                    <option value="dealers">{t("broadcast.dealers")}</option>
                                    <option value="staff">{t("broadcast.staff")}</option>
                                </select>
                            </div>
                            <div style={{ flex: "2 1 220px" }}>
                                <label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("broadcast.link")}</label>
                                <input type="text" className="form-control" placeholder="/cars" value={form.link} onChange={(e) => setForm((p) => ({ ...p, link: e.target.value }))} />
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primary" disabled={sending}>{t("broadcast.send")}</button>
                    </form>
                </div>
            )}

            <h3 style={{ fontSize: "15px", margin: "6px 0 12px" }}>{t("broadcast.history")}</h3>
            {history.length === 0 ? (
                <div style={{ opacity: 0.6 }}>{t("broadcast.none")}</div>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <table className="table" style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th>{t("broadcast.subject")}</th>
                                <th>{t("broadcast.audience")}</th>
                                <th>{t("broadcast.recipients")}</th>
                                <th>{t("broadcast.sentBy")}</th>
                                <th>{t("broadcast.date")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((b) => (
                                <tr key={b.id}>
                                    <td><div style={{ fontWeight: 600 }}>{b.title}</div>{b.body && <div style={{ fontSize: "12px", opacity: 0.7 }}>{b.body}</div>}</td>
                                    <td>{audienceLabel(b.audience)}</td>
                                    <td>{b.recipient_count}</td>
                                    <td>{b.sent_by || "—"}</td>
                                    <td>{b.created_at ? core.formdatDate(b.created_at, "dd-mm-yyyy") : "—"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Broadcast;
